import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { checkAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        window.history.replaceState({}, "", "/dashboard");
        await checkAuth();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, checkAuth]);

  return (
    <div className="min-h-screen grid place-items-center bg-navy-900">
      <div className="flex items-center gap-3 text-muted-foreground">
        <div className="h-4 w-4 rounded-full border-2 border-t-transparent border-gold animate-spin" />
        <span data-testid="auth-callback-loading">Signing you in…</span>
      </div>
    </div>
  );
}
